import { ChartLayoutConfig } from './layout-config';

export function setTickInterval(period: number) {
  switch (period) {
    case 1:
      return 24 * 3600 * 1000 * 365;
    case 2:
      return 24 * 3600 * 1000 * 30 * 3;
    case 3:
      return 24 * 3600 * 1000 * 30;
    case 4:
      return 24 * 3600 * 1000 * 7;
    case 5:
      return 24 * 3600 * 1000;
    case 6:
      return 1;
    default:
      return 24 * 3600 * 1000;
  }
}

function wordwrap(str: string, width: number, brk: string, cut: boolean, truncLimit: number) {
  if ((str === undefined) || (str == null)) {
    return '';
  }
  if (str.length > truncLimit) {
    str = str.substring(0, truncLimit) + '…';
  }
  brk = brk || '\n';
  width = width || 75;
  cut = cut || false;
  if (!str) {
    return str;
  }
  const regex = '.{1,' + width + '}(\\s|$)' + (cut ? '|.{' + width + '}|.+$' : '|\\S+?(\\s|$)');
  return str.match(RegExp(regex, 'g')).join(brk);
}

export function wrapText(
  chartConfig: ChartLayoutConfig,
  str: string,
  lengthSetting: string,
  truncSetting: string,
  brk: string = '<br />'
) {
  const wordwrapConfig = chartConfig.chartStyle('wordwrap') || {};
  const lengthLimit = wordwrapConfig[lengthSetting] || 30;
  const truncLimit = wordwrapConfig[truncSetting] || 150;
  return wordwrap(str, lengthLimit, brk, true, truncLimit);
}

export function escapeHtml(str: string) {
  const entityMap: { [key: string]: string } = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
  };
  return String(str).replace(/[&<>"]/g, s => entityMap[s]);
}
